// Generated by Melange

import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function Awards(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h1", {
        children: "Награды",
        className: "h4 lg:h2 text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "Наша компания постоянно стремится к совершенствованию и откачиванию процессов. Тут представлены наши награды и сертификаты показывающие наши достижения на этом пути.",
        className: "paragraph text-black-landing mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: "The Best Fintech Project of the Year по версии CFO SUMMIT 2019",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("img", {
                className: "mt-6",
                alt: "award",
                src: StaticAsset.src("/static/images/award.png")
              })
            ],
            className: "w-full lg:w-70 bg-bg rounded-lg p-6 mt-6 lg:mt-10 h-[316px] flex flex-col justify-between"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: "First launch of EWA service in CEMEA",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("img", {
                className: "mt-6",
                alt: "award",
                src: StaticAsset.src("/static/images/award2.png")
              })
            ],
            className: "w-full lg:w-70 bg-bg rounded-lg p-6 mt-6 lg:mt-10 h-[316px] flex flex-col justify-between"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: "Visa products and services accelerator Partner",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("img", {
                className: "mt-6",
                alt: "award",
                src: StaticAsset.src("/static/images/award3.png")
              })
            ],
            className: "w-full lg:w-70 bg-bg rounded-lg p-6 mt-6 lg:mt-10 h-[316px] flex flex-col justify-between"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: "Перспективный финтех-стартап. Инновационная компания",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("img", {
                className: "mt-6",
                alt: "award",
                src: StaticAsset.src("/static/images/award4.png")
              })
            ],
            className: "w-full lg:w-70 bg-bg rounded-lg p-6 mt-6 lg:mt-10 h-[316px] flex flex-col justify-between"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: "Парыз 2023",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("img", {
                className: "mt-6",
                alt: "award",
                src: StaticAsset.src("/static/images/award5.png")
              })
            ],
            className: "w-full lg:w-70 bg-bg rounded-lg p-6 mt-6 lg:mt-10 h-[316px] flex flex-col justify-between"
          })
        ],
        className: "flex flex-wrap justify-between"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("p", {
        children: [
          "По вопросам сотрудничества и партнерства пишите на ",
          JsxRuntime.jsx("a", {
            children: "hello@buhta.com",
            className: "text-primary underline",
            href: "mailto:hello@buhta.com"
          })
        ],
        className: "paragraph-small lg:paragraph text-black-landing mt-6 lg:mt-10"
      })
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = Awards;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
